import { ColorInput, from, toHexString } from './color';

const DEFAULT_FONT_SIZE = 16;

export function createText(
  text: string,
  opts?: {
    color?: ColorInput;
    font: { family: string; size?: number; bold?: boolean };
    textAlign?: string;
    textBaseline?: string;
  },
): createjs.Text {
  const font = `${opts?.font.bold ? 'bold' : 'normal'} ${opts?.font.size ?? DEFAULT_FONT_SIZE}px ${opts?.font.family}`;
  const textField = new createjs.Text(
    text,
    font,
    toHexString(from(opts?.color ?? '#000')),
  );
  textField.textAlign = opts?.textAlign ?? 'left';
  textField.textBaseline = opts?.textBaseline ?? 'top';
  return textField;
}
